export const images = {
  booksMockup:
    "https://cdn.magicpatterns.com/uploads/vQaMBft3CvQkh1F5VHcjhB/de_tu_cocina_mockup.webp",
  brownies:
    "https://cdn.magicpatterns.com/patterns/generated-images/0d3e65ca-206d-41c5-bbd6-47e3e8dc8934.jpg",
  cookies:
    "https://cdn.magicpatterns.com/patterns/generated-images/9e076efe-78d6-4aaf-8740-901b6992e1b0.jpg",
  alfajores:
    "https://cdn.magicpatterns.com/patterns/generated-images/135e9b5d-ef5b-4b19-b484-3c0620c5a0ab.jpg",
  homeKitchen:
    "https://cdn.magicpatterns.com/patterns/generated-images/990125b3-d060-4304-936c-6995450197e2.jpg",
};
